/*
 * @Author: 小周
 * @Date: 2023-09-07 11:47:06
 * @LastEditTime: 2023-09-07 11:47:16
 * @LastEditors: MrZHLF 480970024@qq.com
 * @Description: token存储
 */
import store from 'store'
const KEY_RAW = 'dxToken'

/**
 * 设置token信息
 * @param {Object} token token
 */
export const setToken = (token) => {
  setTokenExpireTime(token)
  store.set(KEY_RAW, token)
}

/**
 * 获取token
 */
export const getToken = () => {
  return store.get(KEY_RAW)
}

/**
 * 清除token
 */
export const rmToken = () => {
  store.clearAll()
}

/**
 * 设置token 过期时间 expires_in
 * 原expires_in为一个时间段，例7200s
 * @param {Object} token token信息
 */
function setTokenExpireTime(token) {
  if (token && token['expires_in']) {
    token['expires_in'] += getCurrentTime()
  }

  function getCurrentTime() {
    return Date.parse(new Date()) / 1000
  }
}
